import axios from 'axios'
import { LEADS_ENDPOINT } from 'cfgCommon/endpoints'

export async function getCloseReasonByBussinesUnitByCompany(bussiness_unit) {
    try {
        const response = await axios.get(
          `${LEADS_ENDPOINT}/reasonsByBussinesUnitByCompany`,
          { params: { bussiness_unit } }
        )

        const formattedReasons = response?.data?.data.map(r => ({
            label: r,
            value: r,
        }))

        return formattedReasons
    } catch (e) {
        console.error('Error al obtener motivos de cierre para la empresa', e)
        return []
    }
}
